<script>
import appConfig from "@/app.config";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import satdosyafirma from "@/models/satdosyafirma";
import satdosyafirmafiyat from "../satdosyafirmafiyat/addedit.vue";
import isteklilerceteklifedilenfiyatlar from "./isteklilerceteklifedilenfiyatlar.vue";

export default {
  props: ["satdosyaId"],
  mixins: [apibtoast, apigeneric, satdosyafirma],
  page: {
    title: "Satın Alma Firmalar",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    satdosyafirmafiyat,
    isteklilerceteklifedilenfiyatlar,
  },
  data() {
    return {
      title: this.$t("isteklilerceteklifedilenfiyatlar.Title"),
      items: [
        {
          text: this.$t("isteklilerceteklifedilenfiyatlar.Page.Anasayfa"),
          href: "/",
        },
        {
          text: this.$t("isteklilerceteklifedilenfiyatlar.Page.UstMenu"),
          active: true,
        },
        {
          text: this.$t("isteklilerceteklifedilenfiyatlar.Title"),
          active: true,
        },
      ],
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },
      TableData: {},
      DataUpdate: "",
      AddEdit: "",
      FirmaId: "",
      Firmaadi: "",
      Piyasaarastirmagorevliler: "",
      satdosya: {},
      gecersiz_teklifler: [],
      gecerli_teklifler: [],
    };
  },
  methods: {
    Get() {
      this.ActionsSingleGet({
        Service: "satdosya",
        Id: this.satdosyaId,
      }).then((res) => {
        this.satdosya = res.Data;
      });

      this.ActionsFilterGet({ Service: "satdosyafirma", Page: this.Page, Filter: "&Dosyaid=" + this.satdosyaId + "&Firmaturu=3" }).then((res) => {
        this.TableData = res.Data;
        this.Page.PageDataSize = res.TotalCount;
        this.$emit("aktif_menu_title", this.$t("piyasaarastirmatutanagi.Title"));
      });
      this.teklifkontrol();
    },
    teklifkontrol() {
      let Page = {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      };
      this.ActionsFilterGet({ Service: "satdosyazarfacmakontrol", Page: Page, Filter: "&Dosyaid=" + this.satdosyaId }).then((ressatdosyazarfacmakontrol) => {
        if (ressatdosyazarfacmakontrol) {
          this.gecersiz_teklifler = [];
          this.gecerli_teklifler = [];
          for (var j = 0; j < ressatdosyazarfacmakontrol.Data.length; j++) {
            let istenenbelgeler = JSON.parse(ressatdosyazarfacmakontrol.Data[j].Istenilenbelgeler);

            // alert(Object.values(istenenbelgeler)[0])
            let belge_kontrol = 0;

            for (var i = 0; i < Object.values(istenenbelgeler).length; i++) {
              if (Object.values(istenenbelgeler)[i] > 1) {
                belge_kontrol = 1;
              }
            }

            let zarffirma = "";
            for (i = 0; i < this.TableData.length; i++) {
              if (this.TableData[i].Id == ressatdosyazarfacmakontrol.Data[j].Dosyafirmaid) {
                zarffirma = this.TableData[i];
              }
            }

            if (belge_kontrol == 0 && zarffirma) {
              this.gecerli_teklifler.push(zarffirma);
            } else {
              this.gecersiz_teklifler.push(zarffirma);
            }
          }
        }
      });
    },

    SatDosyaUpdate() {
      this.Update("satdosya", this.satdosya);
    },
  },
  watch: {
    satdosyaId() {
      this.Get();
    },
  },
};
</script>

<template>
  <div class="row">
    <div class="col-xl-12">
      <div class="card">
        <div class="card-body">
          <div class="row mb-2">
            <div class="col-sm-3">
              <b-form-input v-model="satdosya.Isteklilerceteklifedilenfiyatlartarih" id="date" type="datetime-local" @input="SatDosyaUpdate()"></b-form-input>
            </div>

            <div class="col-sm-9">
              <div class="text-sm-end">
                <button type="button" class="btn btn-success btn-rounded mb-2 me-2" v-b-modal.isteklilerceteklifedilenfiyatlar @click="(DataUpdate = satdosyafirmaData), (AddEdit = 'Add')">
                  <i class="mdi mdi-file-export-outline me-1"></i>
                  {{ $t("isteklilerceteklifedilenfiyatlar.Page.TeklifEdilenFiyatlar") }}
                </button>
              </div>
            </div>
          </div>
          <div class="table-responsive">
            <table class="table mb-0">
              <thead class="table-light">
                <tr>
                  <th>{{ $t("isteklilerceteklifedilenfiyatlar.Table.Firmaid") }}</th>
                  <th style="width: 85px; text-align: center;">{{ $t("isteklilerceteklifedilenfiyatlar.Table.Islem") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="Data in gecerli_teklifler" :key="Data.Id">
                  <th scope="row">{{ Data.Firmaadi }}</th>
                  <td style="width: 85px; text-align: center;">
                    <b-button-group>
                      <b-button @click="(FirmaId = Data.Id), (Firmaadi = Data.Firmaadi)" v-b-modal.satdosyafirmafiyat v-tooltip="$t('satdosyafirma.Table.FiyatTeklifleri')" variant="primary">
                        <i class="far fa-edit"></i>
                      </b-button>
                      <b-button v-if="1 == 2" @click="Delete('satdosyafirma', Data.Id)" v-tooltip="$t('satdosyafirma.Table.Sil')" variant="danger">
                        <i class="far fa-trash-alt"></i>
                      </b-button>
                    </b-button-group>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <b-pagination class="pagination pagination-rounded justify-content-end mb-2" v-model="DefaultPage" :total-rows="Page.PageDataSize" :per-page="Page.PageSize" aria-controls="my-table" @input="ChangePage(DefaultPage)"> </b-pagination>
          </div>
          <isteklilerceteklifedilenfiyatlar :satdosyaId="satdosyaId" :Isteklilerceteklifedilenfiyatlartarih="satdosya.Isteklilerceteklifedilenfiyatlartarih" />
          <satdosyafirmafiyat v-if="FirmaId" :FirmaId="FirmaId" :Firmaadi="Firmaadi" :AddEdit="AddEdit" :satdosyaId="satdosyaId" :Fiyatturu="3" />
        </div>
      </div>
    </div>
  </div>
</template>
